export default __webpack_public_path__ + "static/media/intersect-ratio.86ad74e6.jpeg";